import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=cc05b84c&scoped=true&"
import script from "./platform.vue?vue&type=script&lang=js&"
export * from "./platform.vue?vue&type=script&lang=js&"
import style0 from "./platform.vue?vue&type=style&index=0&id=cc05b84c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc05b84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc05b84c')) {
      api.createRecord('cc05b84c', component.options)
    } else {
      api.reload('cc05b84c', component.options)
    }
    module.hot.accept("./platform.vue?vue&type=template&id=cc05b84c&scoped=true&", function () {
      api.rerender('cc05b84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/platform.vue"
export default component.exports